import { webConfig } from '../../../../utils/webConfig';

export const ExternalServicesEndpoints = {
    googleZipLookup: (zip: string) =>
        `https://maps.google.com/maps/api/geocode/json?address=${zip}&sensor=false&key=${webConfig.googlePlaceApiKey}`,
};
